import * as React from 'react';
import { CodeBlock } from '../../cookbook-ui/custom-components/CodeBlock/CodeBlock';
import { TabBar } from '@inmoment/the-kitchen';
import { convertArrayToTabBar } from './utils/tabBarFn';

export interface Props {}

export const data1 = ['Example', 'ErrorObject', 'ErrorStates'].map(convertArrayToTabBar);

export const ToggleTextDocumentation: React.FC<Props> = (props) => {
  const [tab, setTab] = React.useState('Example');
  return (
    <div>
      <p className="kxi-text-300 kxi-text-normal">ToggleText Status</p>
      <br />
      <div style={{ height: 46 }}>
        <TabBar stretch data={data1} color={'orca'} onTabChange={({ tab }) => setTab(tab!.title)} />
      </div>
      {tab === 'Example' && (
        <CodeBlock
          code={`{
  state: 'error';
  text: 'Oh no!';
}`}
        />
      )}
      {tab === 'ErrorObject' && (
        <CodeBlock
          code={`export interface ErrorObject {
  state: ErrorStates;
  text?: string;
}`}
        />
      )}
      {tab === 'ErrorStates' && <CodeBlock code="export type ErrorStates = 'success' | 'warning' | 'error';" />}

      <br />
    </div>
  );
};
